import React from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import StudentInfo from '../../../../components/StudentInfo'
import StudentHeader from '../../../../components/studentHeader'
import { getUrlPushWrapper } from '../../../../routes'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Select, Upload, Input, AutoComplete, DatePicker, Tooltip } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import AddBranch from '../../../../containers/Masters/branch/add/index'
import { hideLoader, showLoader } from '../../../../modules/actions'
import styles from './styles.less'
import { connect } from 'react-redux'
import userRights from "../../../../components/_utils/userRights"
const showChannelPartner = userRights.getUserAuth('showChannelPartner');
const pendingConsultancyAlertToAdmissionVisa = userRights.checkUserRights("pendingConsultancyAlertToAdmissionVisa");

const filesStatusListArray = [
    { id: 'Student Kit & Funds Requirement Issued', display: 'Visa Checklist Issued' },
    { id: 'Tution Fee Pending', display: 'Tution Fee Pending' },
    { id: 'Tution Fee Paid', display: 'Tution Fee Paid' },
    { id: 'COE/Receipt Pending', display: 'COE Pending' },
    { id: 'COE/Receipt Received', display: 'COE Received' },
    { id: 'Financial Documents Pending', display: 'Financial Documents Pending' },
    { id: 'Financial Documents Received', display: 'Financial Documents Received' },
    { id: 'Verification Pending', display: 'Verification Pending' },
    { id: 'Verification Received', display: 'Verification Received' },
    { id: 'CAQ Waiting', display: 'CAQ Waiting' },
    { id: 'CAQ Received', display: 'CAQ Received' },
    { id: 'LOA Received', display: 'LOA Received' },
    { id: 'GIC Waiting', display: 'GIC Waiting' },
    { id: 'GIC Received', display: 'GIC Received' },
    { id: 'CAS Letter Received', display: 'CAS Letter Received' },
    { id: 'Final Visa File Review', display: 'Final Visa File Review' },
    { id: 'Visa File Dispatched', display: 'Visa File Submission' }
]
const visaStatusListArray = [
    { id: 'Visa Waiting', display: 'Visa Waiting' },
    { id: 'Pre-Visa Approval', display: 'Pre-Visa Approval' },
    { id: 'Visa Approved', display: 'Visa Approved' },
    { id: 'Visa Refused', display: 'Visa Refused' },
    { id: 'Visa Withdrawal', display: 'Visa Withdrawal' },
    // { id: 'Refund Waiting', display: 'Refund Waiting' },
];

const documentsUploadedList = [
    { id: 'Yes', display: 'Yes' },
    { id: 'No', display: 'No' }
]

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let useCountrySpecificStatus = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).useCountrySpecificStatus : false;

const { Option } = Select

@Form.create()
class VisaProcessing extends React.Component {
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                dispatch(showLoader())

                if (!this.state.localUser.isFinance || !this.state.localUser.isAdministrator) {
                    if (values.visaStatus === 'Visa Approved' && values.visaUpload.length === 0) {
                        dispatch(hideLoader())
                        return notification.error({
                            message: 'Upload visa decision letter'

                        })
                    }
                }
                if (values.visaStatus === 'Visa Approved' && values.documentsUploaded === 'No') {
                    dispatch(hideLoader())
                    return notification.error({
                        message: 'Documents uploaded value must be Yes'

                    })
                }
                let objValue = {
                    processData: {
                        ...values,
                        studentVisaType: this.state.studentVisaType,
                        studentVisionId: this.state.studentVisionId
                    },
                    inquiryId: this.state.inquiryId,
                }
                if (objValue.channelPartnerId === '') {
                    delete objValue.channelPartnerId
                }
                let { payments, info } = this.state
                let selectedCountryId = info.visaDesk.selectedCourse.countryId
                let { doc: countryData } = await Request.getCountry(selectedCountryId)
                let stage = 3
                if (pendingConsultancyAlertToAdmissionVisa) {
                    let totalAmountPaid = 0;
                    _.each(payments, (item) => {
                        totalAmountPaid += item.paid
                    })

                    if (values.visaStatus === "Visa Approved" && totalAmountPaid < countryData.totalConsultancyFee) {
                        notification.warn({
                            message: `You are submitting visa application without charging stage ${stage} consultancy fees, You are answerable`
                        })
                    }
                }
                let x = await Request.visaProcessApi(objValue)
                dispatch(hideLoader())
                if (!x.error) {
                    if (x.data._doc && x.data._doc.changeOfAgentAccepted === "No" && values.visaStatus === "Visa Approved") {
                        await Request.changeDesk({
                            _id: x.data._doc._id,
                            atLevel: "Archive Desk"
                        })
                    } else if (values.visaStatus === 'Visa Approved') {
                        await this.processClaimDesk(values.claimUserId);
                    }
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountries(params)
            .then(resp => {
                if (resp) {
                    let temp = []
                    _.each(resp.data, (vv) => {
                        let findObj = null
                        if (vv.fundVisaChecklist && vv.fundVisaChecklist.length) {
                            findObj = vv.fundVisaChecklist[0]
                        }
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                            key: vv._id,
                            checkList: findObj && findObj.url ? findObj.url : ''
                        })
                    })
                    this.setState({ countryArr: temp })

                }
            })
            .catch(err => {
                console.log(err)
            })
    }



    handleChange = v => {
        if (v.fileList) {
            this.setState({ vendorPaymentProof: v.fileList })
        }
    }
    handleSwiftChange = v => {
        if (v.fileList) {
            this.setState({ swiftCopy: v.fileList })
        }
    }
    state = {
        loading: false,
        fileStatus: '',
        fileStatusFinal: '',
        countryArr: [],
        selectedCountry: '',
        info: {},
        offerurl: '',
        checkListIndex: null,
        moveToNextDesk: false,
        locationSet: false,
        visible: false,
        channelPartnerList: [],
        selectedChannelPartnerId: '',
        selectedChannelPartnerName: '',
        visibleApprovalDate: false,
        emailLoader: false,
        channelLoader: false,
        universityPartnership: '',
        channelPartners: [],
        vendorArr: [],
        dataSource: [],
        tutionFeeType: '',
        universityArray: [],
        courseArray: [],
        courseFullArray: [],
        allUsers: [],
        filesStatusList: [],
        visaStatusList: [],
        payments: [],
        countryData: {},
        changeOfAgent: false,
        studentVisaType: '',
        studentVisaTypeField: false,
        agentChangeAccepted: '',
        visaRefused: false,
        visaWithDraw: false,
        courseStartDate: null,
        localUser: {},
        filesStatusListArray: [],
        visaStatusListArray: [],
        refundStatusListArray: [],
        totalSwiftAmount: 0,
        swiftTransferDate: null,
        addOnCourses: [],
        multiCourseApproval: false,
        tutionFeeCourse: null,
        courseTutionFee: null,
        courseDetails: null,
        showUpdateFeeButton: false,
        visaDeskRights: null,
        vendorPaymentProof: null,
        vendorPaymentReceiptType: null,
        currency: null
    }

    requestUpdateTutionFee = async () => {
        let { courseTutionFee, course, inquiryId } = this.state;
        let params = {
            courseId: course,
            courseTutionFee,
            inquiryId
        }
        let response = await Request.requestUpdateTutionFeeMaster(params);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
    }

    setFormValues = async doc => {
        const { form } = this.props
        try {
            if (doc) {
                let docLoaded = doc.visaDesk
                let registrationDesk = doc.registrationDesk
                let inputTypes = {}
                _.each(docLoaded, (item, key) => {
                    inputTypes[key] = item
                })
                if (docLoaded.selectedCourse) {
                    this.loadChannelPartnerByUniversityID(docLoaded.selectedCourse.universityId);
                }
                let addOnCoursesIds = [];
                if (docLoaded.addOnCourses) {
                    docLoaded.addOnCourses.map((course) => {
                        addOnCoursesIds.push(course.courseId);
                    })
                }

                this.setState({
                    registrationDesk: registrationDesk,
                    fileStatus: docLoaded.fileStatus,
                    course: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].courseId : '',
                    addOnCourses: addOnCoursesIds,
                    fileStatusFinal: docLoaded.fileStatus,
                    channelPartnerId: docLoaded.channelPartnerId,
                    vendorId: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].vendorId : '',
                    totalSwiftAmount: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].totalSwiftAmount : 0,
                    swiftTransferDate: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].swiftTransferDate : null,
                    instituteStudentId: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].instituteStudentId : '',
                    courseStartDate: moment(docLoaded.courseStartDate),
                    selectedChannelPartnerName: docLoaded['selectedCourse'] ? docLoaded['selectedCourse'].channelPartnerName : '',
                    changeOfAgent: docLoaded['selectedCourse'].changeOfAgent,
                    agentChangeAccepted: doc.changeOfAgentAccepted,
                    selectedUniverityId: docLoaded.selectedCourse ? docLoaded.selectedCourse.universityId : '',
                    tutionFee: docLoaded.selectedCourse ? docLoaded.selectedCourse.tutionFee : 0,
                    courseTutionFee: docLoaded && docLoaded.selectedCourse ? docLoaded.selectedCourse.courseTutionFee : 0,
                    tutionFeeType: docLoaded.selectedCourse ? docLoaded.selectedCourse.tutionFeeType : "",
                    vendorPaymentProof: docLoaded.selectedCourse && docLoaded.selectedCourse.vendorPaymentProof ? docLoaded.selectedCourse.vendorPaymentProof : [],
                    swiftCopy: docLoaded.selectedCourse && docLoaded.selectedCourse.swiftCopy ? docLoaded.selectedCourse.swiftCopy : [],
                    // vendorPaymentReceiptType: docLoaded.selectedCourse && docLoaded.selectedCourse.vendorPaymentReceiptType ? docLoaded.selectedCourse.vendorPaymentReceiptType : '',
                    visaDate: docLoaded && docLoaded.visaDate && moment(docLoaded.visaDate).format('DD-MM-YYYY'),
                    visaRefused: docLoaded && docLoaded.visaStatus === "Visa Refused" ? true : false,
                    refundStatus: docLoaded && docLoaded.visaStatus === "Visa Refused" && docLoaded.refundStatus ? docLoaded.refundStatus : null,
                })

                if (docLoaded) {
                    if (docLoaded.documentsUploaded === 'Yes') {

                        this.setState({
                            savedVisa: docLoaded,
                            moveToNextDesk: doc.atLevel && doc.atLevel === 'Visa Desk' ? true : false
                        })
                    }
                    if (docLoaded.visaStatus === 'Visa Approved') {
                        this.setState({ visibleApprovalDate: true })
                    }
                    if (!docLoaded.studentVisaType) {
                        docLoaded.studentVisaType = 'OffShore (Native to Abroad)';
                    }
                    if (docLoaded.studentVisaType != 'OffShore (Native to Abroad)') {
                        this.setState({ studentVisaTypeField: true })
                    }
                }
                setTimeout(() => {

                    if (docLoaded.visaSource === 'Channel Partner') {
                        this.loadChannelPartners('Channel Partner')
                        this.setState({ locationSet: true })
                    }
                    if (docLoaded['submissionDate']) {
                        docLoaded['submissionDate'] = moment(docLoaded['submissionDate'])
                    }
                    if (this.state.visibleApprovalDate && docLoaded['visaApprovalDate']) {
                        docLoaded['visaApprovalDate'] = moment(docLoaded['visaApprovalDate'])
                    }
                    if (docLoaded['arrivalDate']) {
                        docLoaded['arrivalDate'] = moment(docLoaded['arrivalDate'])
                    }

                    form.setFieldsValue({
                        documentsUploaded: 'No',
                        claimUserId: doc.claimUserId
                    })
                    form.setFieldsValue(docLoaded)


                }, 1000)

                this.setState({ info: doc, studentVisionId: doc.visaDesk.studentVisionId, studentVisaType: doc.visaDesk.studentVisaType })
            }

        } catch (e) {
            console.log(e)
        }
    }


    loadChannelPartners = (source) => {
        if (source === 'Channel Partner') {
            return new Promise(async resolve => {

                let { data: channelPartnerList } = await Request.getSimplePartners({
                    results: 10000
                })
                this.setState({ channelPartnerList })

                this.setState({
                    locationSet: true
                })
            })
        } else {
            this.setState({
                locationSet: false
            })
        }
    }

    loadAllVendoras = async () => {
        let response = await Request.getAllVendorWithOutAuth({
            results: 10000
        });
        this.setState({ vendorArr: response.data });
    }
    loadChannelPartnerByUniversityID = (uniId) => {
        return new Promise(async resolve => {
            let data = await Request.loadChannelPartnerByUniversityID({ uniId });
            let courseArray = this.state.courseFullArray[uniId];
            this.setState({ channelPartners: data.channelPartners, universityPartnership: data.universityPartnership, courseArray });
        })
    }

    loadProcessStatus = async (uniId) => {
        if (!uniId) {
            return
        }
        let response = await Request.getUniversity(uniId)
        let universityCountryId = response && response.doc && response.doc.universityCountryId
        if (!universityCountryId) {
            return
        }
        let countryResponse = await Request.getCountry(universityCountryId)
        let process = countryResponse && countryResponse.doc && countryResponse.doc.process
        let filesStatusListArray = []
        let visaStatusListArray = []
        let refundStatusListArray = []
        _.each(process, (pro) => {
            if (pro.desk === "Student File Status" && pro.active === true) {
                filesStatusListArray.push({ id: pro.systemKey || pro.name, display: pro.name })
            } else if (pro.desk === "Visa File Status" && pro.active === true) {
                visaStatusListArray.push({ id: pro.systemKey || pro.name, display: pro.name })
            } else if (pro.desk === "Refund Status" && pro.active === true) {
                refundStatusListArray.push(pro.systemKey || pro.name)
            }
        })
        this.setState({ visaStatusListArray, filesStatusListArray, refundStatusListArray })
    }

    downloadFile() {
        let cloneCountryArr = _.clone(this.state.countryArr)
        if (cloneCountryArr[this.state.checkListIndex]) {
            if (cloneCountryArr[this.state.checkListIndex].checkList) {
                let checkListValue = cloneCountryArr[this.state.checkListIndex].checkList
                let offerurl = checkListValue
                window.open(offerurl, '_blank')
            } else {
                notification.error({
                    message: 'CheckList',
                    description: `Sorry, ${cloneCountryArr[this.state.checkListIndex].display} Checklist not available.`
                })
            }
        } else {
            notification.error({
                message: 'CheckList',
                description: 'Please choose Country.'
            })
        }
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }

    updateStatus = async () => {
        const { courseArray, addOnCourses } = this.state
        const { dispatch } = this.props
        if (!this.state.fileStatus) {
            notification.error({
                message: 'Warning',
                description: 'Please Select File Status'
            })
            return
        }
        if (this.state.fileStatus === 'Visa File Dispatched' || this.state.fileStatus === 'Visa File Submission') {
            if (!this.state.selectedUniverityId) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Select Selected University'
                })
                return
            }
            if (!this.state.selectedChannelPartnerId && this.state.universityPartnership === 'Channel Partner') {
                notification.error({
                    message: 'Warning',
                    description: 'Please Select university channel partner'
                })
                return
            }
            if (!this.state.course) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Select selected course'
                })
                return
            }
            if (!this.state.tutionFee) {
                notification.error({
                    message: 'Warning',
                    description: 'Please enter tution fee'
                })
                return
            }
            if (!this.state.vendorId) {
                notification.error({
                    message: 'Warning',
                    description: 'Please select Vendor ID'
                })
                return
            }

            if (!this.state.vendorPaymentProof) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Upload Fee Receipt'
                })
                return
            }

            if (!this.state.swiftCopy) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Upload Swift Copy'
                })
                return
            }


            if (this.state.vendorId && !this.state.totalSwiftAmount) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Enter Amount Transferred (as Per SWIFT)'
                })
                return
            }

            if (this.state.vendorId && this.state.totalSwiftAmount && !this.state.swiftTransferDate) {
                notification.error({
                    message: 'Warning',
                    description: 'Please Choose SWIFT Amount Transfer Date'
                })
                return
            }
        }
        let obj = {
            inquiryId: this.state.inquiryId,
            fileStatus: this.state.fileStatus,
            selectedCourse: {},
            leadSource: this.state.universityPartnership
        }

        if (this.state.addOnCourses && this.state.addOnCourses.length > 0) {
            let addOnCourses = [];
            for (let i = 0; i < this.state.addOnCourses.length; i++) {
                let foundCourse = _.find(courseArray, (item) => {
                    return item.courseId === this.state.addOnCourses[i]
                });
                if (foundCourse && foundCourse.countryId) {
                    let { doc: countryData } = await Request.getCountry(foundCourse.countryId)
                    let obj = {
                        courseId: foundCourse.courseId,
                        courseName: foundCourse.courseName,
                        universityId: foundCourse.universityId,
                        universityInstitutionName: foundCourse.universityInstitutionName,
                        countryId: foundCourse.countryId,
                        countryName: countryData && countryData.countryName,
                        currency: countryData && countryData.currencyName,
                        currencyRate: countryData && countryData.currencyRate,
                        campusId: foundCourse.campusId,
                        campusName: foundCourse.campusName,
                        instituteStudentId: foundCourse.stage2.instituteStudentId,
                        changeOfAgent: foundCourse.changeOfAgent,
                        universityPartnership: this.state.universityPartnership,
                        tutionFee: foundCourse.tutionFee,
                        tutionFeeType: this.state.tutionFeeType,
                        vendorId: this.state.vendorId,
                        swiftTransferDate: this.state.swiftTransferDate,
                        totalSwiftAmount: this.state.totalSwiftAmount,
                        vendorPaymentProof: this.state.vendorPaymentProof,
                        swiftCopy: this.state.swiftCopy,
                        // vendorPaymentReceiptType: this.state.vendorPaymentReceiptType,
                        channelPartnerId: this.state.selectedChannelPartnerId,
                        courseStartDate: moment.utc(foundCourse.stage2.courseStartDate, "YYYY-MM-DD").toDate(),
                    }
                    addOnCourses.push(obj);
                }
            }
            obj.addOnCourses = addOnCourses;
        }
        if (this.state.course) {
            let foundCourse = _.find(courseArray, (item) => {
                return item.courseId === this.state.course
            });
            if (foundCourse && foundCourse.countryId) {
                let { doc: countryData } = await Request.getCountry(foundCourse.countryId)
                obj.selectedCourse.courseId = foundCourse.courseId
                obj.selectedCourse.courseName = foundCourse.courseName
                obj.selectedCourse.universityId = foundCourse.universityId
                obj.selectedCourse.universityInstitutionName = foundCourse.universityInstitutionName
                obj.selectedCourse.countryId = foundCourse.countryId
                obj.selectedCourse.countryName = countryData && countryData.countryName
                obj.selectedCourse.currency = countryData && countryData.currencyName
                obj.selectedCourse.currencyRate = countryData && countryData.currencyRate
                obj.selectedCourse.campusId = foundCourse.campusId
                obj.selectedCourse.campusName = foundCourse.campusName
                obj.selectedCourse.instituteStudentId = foundCourse.stage2.instituteStudentId
                obj.selectedCourse.changeOfAgent = this.state.changeOfAgent
                obj.selectedCourse.universityPartnership = this.state.universityPartnership
                obj.selectedCourse.tutionFee = this.state.tutionFee
                obj.selectedCourse.courseTutionFee = this.state.courseTutionFee
                obj.selectedCourse.tutionFeeType = this.state.tutionFeeType
                obj.selectedCourse.vendorId = this.state.vendorId
                obj.selectedCourse.swiftTransferDate = this.state.swiftTransferDate
                obj.selectedCourse.totalSwiftAmount = this.state.totalSwiftAmount
                obj.selectedCourse.vendorPaymentProof = this.state.vendorPaymentProof
                obj.selectedCourse.swiftCopy = this.state.swiftCopy
                // obj.selectedCourse.vendorPaymentReceiptType = this.state.vendorPaymentReceiptType
                obj.selectedCourse.channelPartnerId = this.state.selectedChannelPartnerId

                obj.courseStartDate = moment.utc(this.state.courseStartDate, "YYYY-MM-DD").toDate();
                this.setState({ countryData })
            }
        }
        dispatch(showLoader())
        let { countryData, payments, fileStatus } = this.state
        let stage = 2
        if (pendingConsultancyAlertToAdmissionVisa) {
            let paymentAccordingStages = countryData.totalConsultancyFee / 3
            let totalAmountPaid = 0;
            _.each(payments, (item) => {
                totalAmountPaid += item.paid
            })
            if (fileStatus === "Visa File Dispatched" && totalAmountPaid < paymentAccordingStages * stage) {
                notification.warn({
                    message: `You are submitting visa application without charging stage ${stage} consultancy fees, You are answerable`
                })
            }
        }
        Request.visaProcessFileStatus(obj).then((resp) => {
            if (resp.success) {
                notification.success({
                    message: 'Success',
                    description: resp.msg
                })
                this.setState({
                    fileStatusFinal: this.state.fileStatus,
                })

                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            } else {
                notification.error({
                    message: 'Error',
                    description: resp.msg
                })
            }
            dispatch(hideLoader())
        })
    }


    async getUniversityDetails(data) {
        let countryId
        if (data.universityId) {
            await Request.getUniversity(data.universityId).then((res) => {
                countryId = res.doc.universityCountryId
            })
        } else {
            countryId = data.countryId
        }
        let countryResponse = await Request.getCountry(countryId);
        let response = await Request.getStatusByUniversityCountry({ countryId, desk: "Visa Status" });
        let visaStatus = [];
        let fileStatus = [];
        _.each(response.data, (item) => {
            if (item.statusType === "File Status") {
                fileStatus.push({ id: item.statusName, display: item.statusName })
            } else if (item.statusType === "Visa Status") {
                visaStatus.push({ id: item.statusName, display: item.statusName })
            }
        })
        this.setState({ filesStatusList: fileStatus, visaStatusList: visaStatus, multiCourseApproval: countryResponse && countryResponse.doc && countryResponse.doc.multiCourseApproval ? countryResponse.doc.multiCourseApproval : false, currency: countryResponse && countryResponse.doc && countryResponse.doc.currencyName ? countryResponse.doc.currencyName : '' })

    }

    saveChannelPartner() {
        const { dispatch } = this.props

        let obj = {
            inquiryId: this.state.inquiryId,
            channelPartnerId: this.state.channelPartnerId,
            visaSource: this.state.visaSource
        }

        this.setState({ channelLoader: true });

        Request.saveChannelPartner(obj).then((resp) => {
            this.setState({ channelLoader: false });

            if (resp.success) {
                notification.success({
                    message: 'Success',
                    description: resp.msg
                })
            } else {
                notification.error({
                    message: 'Error',
                    description: resp.msg
                })
            }
            dispatch(hideLoader())
        })
    }

    processClaimDesk = async (claimUserId) => {
        const { dispatch } = this.props
        dispatch(showLoader())
        Request.movedToClaimDesk({
            _id: this.state.inquiryId,
            claimUserId: claimUserId
        }).then(({ data, error, message }) => {
            dispatch(hideLoader())

            if (!error) {
                this.setState({ moveToNextDesk: false })
                notification.success({
                    message: message
                })
                dispatch(getUrlPushWrapper('desk.visa'))
            } else {
                notification.error({
                    message: message
                })
            }
        })
    }

    async emailCheckList() {
        const { dispatch } = this.props
        let cloneCountryArr = _.clone(this.state.countryArr)
        if (cloneCountryArr[this.state.checkListIndex]) {
            if (cloneCountryArr[this.state.checkListIndex].checkList) {
                let checkListValue = cloneCountryArr[this.state.checkListIndex].checkList
                let offerurl = MEDIA_URL + checkListValue
                let obj = {
                    inquiryId: this.state.inquiryId,
                    checklistPath: offerurl,
                    country: cloneCountryArr[this.state.checkListIndex].display
                }

                this.setState({ emailLoader: true });
                let resp = await Request.emailCheckList(obj)
                this.setState({ emailLoader: false });

                if (resp.success) {
                    notification.success({
                        message: 'CheckList',
                        description: resp.message
                    })
                } else {
                    notification.error({
                        message: 'CheckList',
                        description: resp.message
                    })
                }
                dispatch(hideLoader())
            } else {
                notification.error({
                    message: 'CheckList',
                    description: `Sorry, ${cloneCountryArr[this.state.checkListIndex].display} Checklist not available.`
                })
            }
        } else {
            notification.error({
                message: 'CheckList',
                description: 'Please choose Country.'
            })
        }
    }

    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ visaDeskRights: userRights.VisaDesk })
    }

    async componentDidMount() {
        this.loadAllVendoras();
        this.loadUserRights();
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')

        if (inquiryId) {
            let { doc } = await Request.getInquiry(inquiryId);
            if (doc && doc.applicationsDesk && doc.applicationsDesk.course) {
                let courses = _.filter(doc.applicationsDesk.course, (i) => {
                    return i.stage2 && (
                        i.stage2.offerStatus === 'Conditional Offer Received' ||
                        i.stage2.offerStatus === 'Unconditional Offer Received' && _.isEmpty(!i.stage2.offerUpload)
                    )
                })
                let courseFullArray = [];
                let universityArray = [];
                let removeDuplicateUni = [];
                for (let index = 0; index < courses.length; index++) {
                    const course = courses[index];
                    if (!removeDuplicateUni.includes(course.universityId)) {
                        universityArray.push({
                            _id: course.universityId,
                            universityInstitutionName: course.universityInstitutionName,
                            countryId: course.countryId
                        });
                        removeDuplicateUni.push(course.universityId);
                    }
                    if (courseFullArray[course.universityId] === undefined) {
                        courseFullArray[course.universityId] = [];
                    }
                    courseFullArray[course.universityId].push(course);
                }
                this.setState({
                    courseFullArray: courseFullArray,
                    universityArray: universityArray
                })
            }

            if (doc.visaDesk.selectedCourse) {
                await this.getUniversityDetails({ countryId: doc.visaDesk.selectedCourse.countryId });
                this.loadProcessStatus(doc.visaDesk.selectedCourse.universityId);
                let courseArray = this.state.courseFullArray[doc.visaDesk.selectedCourse.universityId];
                this.setState({
                    courseArray
                }, () => {
                    this.setChannelPartnerDetails(doc.visaDesk.selectedCourse.courseId);
                    this.checkChangeOfAgent(doc.visaDesk.selectedCourse.courseId);
                })
            }

            this.setState({
                inquiryId: inquiryId,
                payments: doc.payments
            })
            this.setState({ info: doc })
            this.setFormValues(doc)
        }
        this.loadAllCountries();
        let localUser = JSON.parse(localStorage.getItem("user"));

        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isClaim: true,
            active: true,
            // userBranch: localUser ? localUser.userBranch : null,
            userId: localUser._id,
        });
        allUsers.sort((a, b) => a.name.localeCompare(b.name));
        this.setState({ allUsers: allUsers, localUser: localUser });
    }

    setChannelPartnerDetails(courseId) {
        let courseArray = this.state.courseArray;
        courseArray && courseArray.map((course, key) => {
            if (course.courseId === courseId) {
                this.setState({ selectedChannelPartnerName: course.channelPartnerName, selectedChannelPartnerId: course.channelPartnerId, instituteStudentId: course.stage2.instituteStudentId, courseStartDate: course.stage2.courseStartDate });
            }
        })
    }


    async getCourseDetails(courseId) {
        let { doc } = await Request.getCourse(courseId);
        let tutionFee = doc.tuitionFee ? parseFloat(doc.tuitionFee) : 0;
        if (doc && doc.tutionFeeStructure !== "Fixed" && doc.tutionFeeList && doc.tutionFeeList.length > 0) {
            let firstIndex = doc.tutionFeeList[0];
            tutionFee = firstIndex.tutionFee ? firstIndex.tutionFee : 0;
        }
        this.setState({ tutionFeeCourse: tutionFee, courseDetails: doc });
    }


    matchTutionFee(fee) {
        let { tutionFeeCourse, visaDeskRights } = this.state;

        const normalize = (val) => parseFloat(String(val).replace(/,/g, '').trim());

        const feeValue = normalize(fee);
        const courseValue = normalize(tutionFeeCourse);

        let showButton = false;
        if (feeValue !== courseValue && !visaDeskRights.viewByBranch) {
            showButton = true;
        }

        this.setState({
            showUpdateFeeButton: showButton
        });
    }

    doCourseWork(courseId) {
        this.setChannelPartnerDetails(courseId);
        this.checkChangeOfAgent(courseId);
        this.getCourseDetails(courseId);
    }

    checkChangeOfAgent(courseId) {
        let courseArray = this.state.courseArray;
        let findIn = courseArray && courseArray.find(val => val.courseId === courseId)
        if (findIn) {
            this.setState({ changeOfAgent: findIn.changeOfAgent })
        }
    }

    handleSearch = async (value) => {
        this.setState({ studentVisionId: value });
        let dataSource = [];
        if (value.length > 3) {
            let response = await Request.handleSearchStudent({
                searchField: value,
                results: 30
            });
            if (response.data) {
                if (response.data) {
                    response.data.map((student) => {
                        dataSource.push(student.id + ' - ' + student.studentName)
                    })
                }
            }
        }
        this.setState({ dataSource });
    };

    onSelect = value => {
        this.setState({ studentVisionId: value });
        this.props.form.setFieldsValue({ studentVisionId: value })
    };

    render() {
        let { visibleApprovalDate, visaRefused, visaWithDraw, currency } = this.state
        const { dispatch } = this.props
        const {
            form: { getFieldDecorator }
        } = this.props

        const { countryArr, vendorArr, studentVisaType, studentVisaTypeField, info, offerurl, courseArray, visaDate, universityPartnership, universityArray, visaStatusList, filesStatusList, changeOfAgent, filesStatusListArray: countryFilesStatusList, visaStatusListArray: countryVisaStatusList, refundStatusListArray: countryRefundStatusList } = this.state

        const inputFields = {
            fields: [
                // {
                //     label: 'Submission Date',
                //     key: 'submissionDate',
                //     type: 'date',
                //     required: true,
                //     disabledDate: (current) => {
                //         return current && current > new Date(); // ❌ disable future
                //     }
                // },
                {
                    label: 'Visa Application No',
                    key: 'fileNo',
                    required: true,
                    placeholder: 'File No',
                },

                {
                    label: 'Visa Application Status',
                    key: 'visaStatus',
                    required: true,
                    type: 'select',
                    options: useCountrySpecificStatus && countryVisaStatusList && countryVisaStatusList.length ? countryVisaStatusList : visaStatusListArray,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ visaStatus: v })
                        if (v === 'Visa Approved') {
                            this.setState({ visibleApprovalDate: true, visaRefused: false, visaWithDraw: false })
                        } else if (v === "Visa Refused") {
                            this.setState({ visaRefused: true, visaWithDraw: false, visibleApprovalDate: false })
                        } else if (v === "Visa Withdrawal") {
                            this.setState({ visaWithDraw: true, visibleApprovalDate: false, visaRefused: false })
                        } else {
                            this.setState({ visibleApprovalDate: false, visaRefused: false, visaWithDraw: false })

                        }
                    }
                },
                {
                    label: 'Visa Refusal Reason',
                    key: 'visaRefusedReason',
                    required: visaRefused,
                    hidden: !visaRefused,
                    type: 'text'
                },
                {
                    label: 'Refund Status',
                    key: 'refundStatus',
                    required: visaRefused,
                    hidden: !visaRefused,
                    type: 'select',
                    options: useCountrySpecificStatus && countryRefundStatusList && countryRefundStatusList.length ? countryRefundStatusList : ["Refund Waiting", "Refund Proccessed", "Refund Completed", "No Refund Required"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ refundStatus: v })
                    }
                },
                {
                    label: 'Visa WithDrawal Reason',
                    key: 'visaWithdrawalReason',
                    required: visaWithDraw,
                    hidden: !visaWithDraw,
                    type: 'text'
                },
                {
                    label: 'Visa Approval Date',
                    key: 'visaApprovalDate',
                    type: 'date',
                    required: true,
                    hidden: visibleApprovalDate ? false : true,
                    customProps: {
                        disabledDate: d => !d || d.isAfter(moment())
                    }
                },
                {
                    label: 'Visa Documents Uploaded ?',
                    key: 'documentsUploaded',
                    required: visibleApprovalDate,
                    type: 'select',
                    options: documentsUploadedList,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ documentsUploaded: v })
                    }
                },
                {
                    label: 'Expected Travel Date',
                    key: 'arrivalDate',
                    type: 'date',
                    hidden: visibleApprovalDate ? false : true,
                    required: visibleApprovalDate,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'Upload Visa',
                    key: 'visaUpload',
                    type: 'file'
                },
                {
                    label: "Claim Desk User",
                    key: "claimUserId",
                    type: "select",
                    mode: 'multiple',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.name,
                    hidden: visibleApprovalDate ? false : true,
                    options: this.state.allUsers ? this.state.allUsers : {},
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ claimUserId: v });
                    },
                }
            ]
        }

        return (
            <PageHeaderWrapper title={'Visa Processing Desk'}>
                {
                    info && info._id ? <div>
                        <div style={{ marginBottom: 10 }}>
                            <StudentHeader
                                info={this.state.inquiryId}
                                rollBackLevel={'Application Desk'}
                                done={() => {
                                    dispatch(getUrlPushWrapper('desk.visa'))
                                }}
                                data={info}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div> : null}
                {
                    info ? <Card style={{ marginBottom: 10 }}>
                        <StudentInfo
                            info={info}

                        />
                    </Card> : null
                }
                <Card>
                    <Row>
                        <Col span={17}>
                            <h2 style={{ marginLeft: 5 }}>To Be Filled By Visa Support Team </h2>
                            <Row style={{ marginBottom: 10 }}>
                                <div>
                                    <Row style={{ marginTop: 10 }}>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    Student Name
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && info.studentName}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    Mobile
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && (info.countryCode ? info.countryCode : '') + '' + info.mobile}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    Email
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && info.emailId}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    WhatsApp
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && (info.countryCode ? info.countryCode : '') + '' + (info.watsupp ? info.watsupp : info.mobile)}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    DOB
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && info.dateOfBirth ? moment(info.dateOfBirth).format(dateFormat) : ''}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    Passport No.
                                                </div>
                                            </Col>
                                            <Col span={12} style={{ "marginTop": "8px" }}>
                                                <b>{info && info.profile && info.profile.passportNumber ? info.profile.passportNumber : 'NA'}</b>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    Select Final Institute
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <Select value={this.state.selectedUniverityId}
                                                    style={{ width: 400 }}
                                                    showSearch={true}
                                                    options={universityArray}
                                                    required={true}
                                                    onChange={(v) => {
                                                        this.getUniversityDetails({ universityId: v })
                                                        this.setState({
                                                            selectedUniverityId: v
                                                        });
                                                        this.loadChannelPartnerByUniversityID(v);
                                                        this.loadProcessStatus(v)
                                                    }}>
                                                    {universityArray && universityArray.map((item, key) => {
                                                        return (
                                                            <Option key={key} value={item._id}>{item.universityInstitutionName}</Option>
                                                        )
                                                    })}

                                                </Select>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 10 }}>
                                            <Col span={6}>
                                                <div className={styles.formLabel}>
                                                    File Status
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <Select value={this.state.fileStatus}
                                                    style={{ width: 300 }}
                                                    showSearch={true}
                                                    onChange={(v) => {
                                                        this.setState({
                                                            fileStatus: v
                                                        })
                                                    }}>
                                                    {(useCountrySpecificStatus && countryFilesStatusList && countryFilesStatusList.length ? countryFilesStatusList : filesStatusListArray).map((item, key) => {
                                                        return (
                                                            <Option key={key} value={item.id}>{item.display}</Option>
                                                        )
                                                    })}

                                                </Select>
                                            </Col>
                                        </Row>
                                    </Row>

                                    {
                                        universityPartnership ?
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        University Type
                                                    </div>
                                                </Col>
                                                <Col span={12} style={{ "marginTop": "8px" }}>
                                                    <b>{universityPartnership}</b>
                                                </Col>
                                            </Row>
                                            : null
                                    }

                                    {
                                        courseArray && courseArray.length ?
                                            <>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div className={styles.formLabel}>
                                                            Select Final Course <b>(To Join)</b>
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Select value={this.state.course}
                                                            style={{ width: 400 }}
                                                            showSearch={true}
                                                            options={courseArray}
                                                            required={true}
                                                            onChange={(v) => {
                                                                this.setState({
                                                                    course: v
                                                                });
                                                                this.doCourseWork(v);
                                                                // this.setChannelPartnerDetails(v);
                                                                // this.checkChangeOfAgent(v);
                                                            }}>
                                                            {courseArray && courseArray.map((item, key) => {
                                                                return (
                                                                    <Option key={key} value={item.courseId}>{item.courseName}</Option>
                                                                )
                                                            })}

                                                        </Select>
                                                    </Col>
                                                </Row>
                                                {this.state.multiCourseApproval ?
                                                    <Row style={{ marginTop: 10 }}>
                                                        <Col span={6}>
                                                            <div className={styles.formLabel}>
                                                                Addon Courses <b>(To Join - If Any)</b>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Select value={this.state.addOnCourses}
                                                                style={{ width: 400 }}
                                                                showSearch={true}
                                                                mode="multiple"
                                                                options={courseArray}
                                                                required={true}
                                                                onChange={(v) => {
                                                                    this.setState({
                                                                        addOnCourses: v
                                                                    });
                                                                    // this.setChannelPartnerDetails(v);
                                                                    this.checkChangeOfAgent(v);
                                                                }}>
                                                                {courseArray && courseArray
                                                                    .filter(item => item.courseId !== this.state.course)
                                                                    .map((item, key) => (
                                                                        <Option key={key} value={item.courseId}>{item.courseName}</Option>
                                                                    ))}
                                                                {/* {courseArray && courseArray.map((item, key) => {
                                return (
                                <Option key={key} value={item.courseId}>{item.courseName}</Option>
                                )
                                })} */}

                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                    : null}
                                                <Row style={{ marginTop: 10 }}>

                                                    <Col span={6}>
                                                        <div className={styles.formLabel}>
                                                            Commissionable Tution Fee ({currency})
                                                            <span className='tooltip'>
                                                                ?
                                                                <span className="tooltiptext">
                                                                    Total Tution fee of Year as per Offer Letter/COE
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </Col>

                                                    <Col span={12}>
                                                        <Input
                                                            type="number"
                                                            value={this.state.courseTutionFee}
                                                            required={true}
                                                            onChange={(v) => {
                                                                this.setState({
                                                                    courseTutionFee: v.target.value
                                                                });
                                                                this.matchTutionFee(v.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                    {
                                                        this.state.tutionFeeCourse && (
                                                            <Col span={8} style={{ marginLeft: 10 }}>
                                                                <span>
                                                                    Fee as per Course Master:<b>{this.state.tutionFeeCourse}</b>
                                                                    {this.state.showUpdateFeeButton && (
                                                                        <Tooltip title="Send Tution Fee Update Request" style={{ marginLeft: 5 }}>
                                                                            <Button
                                                                                shape='circle'
                                                                                type='primary'
                                                                                size='small'
                                                                                icon='sync'
                                                                                onClick={() => this.requestUpdateTutionFee()}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                </span>
                                                            </Col>
                                                        )
                                                    }


                                                </Row>
                                                <Row style={{ marginTop: 10 }}>

                                                    <Col span={6}>
                                                        <div className={styles.formLabel} >
                                                            Tution Fee ({currency})  <span className='tooltip'>?<span className="tooltiptext">Tution fee as paid per Offer Letter/COE</span></span>
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Input
                                                            type={'number'}
                                                            value={this.state.tutionFee}
                                                            // disabled={!showChannelPartner}
                                                            required={true}
                                                            onChange={(v) => {
                                                                this.setState({
                                                                    tutionFee: v.target.value
                                                                });
                                                            }} />
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div className={styles.formLabel} >
                                                            Tution Fee Type
                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Select value={this.state.tutionFeeType} style={{ width: 400 }} required={true} onChange={(v) => {
                                                            this.setState({
                                                                tutionFeeType: v
                                                            });
                                                        }}>
                                                            <Option value={'Gross Tution Fees'}>Gross Tution Fees</Option>
                                                            <Option value={'Net Tution Fess'}>Net Tution Fees</Option>
                                                        </Select>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div className={styles.formLabel} >
                                                            Institute Student Id <span className='tooltip'>?<span className="tooltiptext">If Student institute ID not reflect here, Please press update button.</span></span>
                                                        </div>
                                                    </Col>
                                                    <Col span={12} style={{ "marginTop": "8px" }}>
                                                        <b>{this.state.instituteStudentId}</b>
                                                    </Col>
                                                </Row>

                                                <Row style={{ marginTop: 10 }}>
                                                    <Col span={6}>
                                                        <div className={styles.formLabel}>
                                                            Course Start Date{' '}
                                                            <span className="tooltip">
                                                                ?
                                                                <span className="tooltiptext">
                                                                    If Student Course Start Date is not Correct, Please update.
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </Col>

                                                    <Col span={12}>
                                                        <DatePicker
                                                            style={{ width: '100%' }}
                                                            placeholder="dd-mm-yyyy"
                                                            format="DD-MM-YYYY"
                                                            value={
                                                                this.state.courseStartDate
                                                                    ? moment(this.state.courseStartDate, 'YYYY-MM-DD')
                                                                    : null
                                                            }
                                                            onChange={(date) => {
                                                                this.setState({
                                                                    courseStartDate: date ? date.format('YYYY-MM-DD') : ''
                                                                });
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                            </>
                                            : null
                                    }
                                    {
                                        universityPartnership && universityPartnership !== 'Direct' && showChannelPartner ?
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Channel Partner
                                                    </div>
                                                </Col>
                                                <Col span={12} style={{ "marginTop": "8px" }}>
                                                    <b>{this.state.selectedChannelPartnerName}</b>
                                                </Col>
                                            </Row>
                                            : null
                                    }
                                    {
                                        courseArray && courseArray.length ?
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Select Forex Vendor
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <Select value={this.state.vendorId}
                                                        style={{ width: 400 }}
                                                        showSearch={true}
                                                        options={vendorArr}
                                                        required={true}
                                                        onChange={(v) => {
                                                            this.setState({
                                                                vendorId: v
                                                            });
                                                        }}>
                                                        {vendorArr && vendorArr.map((vendor, key) => {
                                                            return (
                                                                <Option key={key} value={vendor._id}>{vendor.vendorName}</Option>
                                                            )
                                                        })}

                                                    </Select>
                                                </Col>
                                            </Row>
                                            : null
                                    }
                                    {courseArray && courseArray.length > 0 && this.state.vendorId ?
                                        <>
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Funds Trfd as per SWIFT ({currency})
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <Input
                                                        type={'number'}
                                                        value={this.state.totalSwiftAmount}
                                                        // disabled={!showChannelPartner}
                                                        required={true}
                                                        onChange={(v) => {
                                                            this.setState({
                                                                totalSwiftAmount: Number(v.target.value)
                                                            });
                                                        }} />
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Fee Receipt
                                                    </div>
                                                </Col>
                                                <Col span={12} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Upload
                                                        fileList={this.state.vendorPaymentProof}
                                                        action={`${LAPI_URL}/filesUploader`}
                                                        onChange={this.handleChange}>
                                                        <Button>
                                                            <Icon type="upload" /> Fee Receipt
                                                        </Button>
                                                    </Upload>
                                                    {this.state.vendorPaymentProof && this.state.vendorPaymentProof.length > 0 && this.state.vendorPaymentProof[0].url && (
                                                        <Tooltip title="View Uploaded Fee Receipt">
                                                            <Button
                                                                size='small'
                                                                shape="circle"
                                                                icon="eye"
                                                                type="default"
                                                                onClick={() => window.open(`${MEDIA_URL}${this.state.vendorPaymentProof[0].url}`, '_blank')}
                                                            />
                                                        </Tooltip>
                                                    )}

                                                </Col>


                                            </Row>
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Swift Copy
                                                    </div>
                                                </Col>
                                                <Col span={12} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Upload
                                                        fileList={this.state.swiftCopy}
                                                        action={`${LAPI_URL}/filesUploader`}
                                                        onChange={this.handleSwiftChange}>
                                                        <Button>
                                                            <Icon type="upload" /> Swift Copy
                                                        </Button>
                                                    </Upload>
                                                    {this.state.swiftCopy && this.state.swiftCopy.length > 0 && this.state.swiftCopy[0].url && (
                                                        <Tooltip title="View Uploaded Swift Copy">
                                                            <Button
                                                                size='small'
                                                                shape="circle"
                                                                icon="eye"
                                                                type="default"
                                                                onClick={() => window.open(`${MEDIA_URL}${this.state.swiftCopy[0].url}`, '_blank')}
                                                            />
                                                        </Tooltip>
                                                    )}

                                                </Col>


                                            </Row>
                                            {/* <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Receipt Type
                                                    </div>
                                                </Col>
                                                <Select value={this.state.vendorPaymentReceiptType} style={{ width: 400 }} required={true} onChange={(v) => this.setState({ vendorPaymentReceiptType: v })}>
                                                    <Option value={"Swift Copy"}>Swift Copy</Option>
                                                    <Option value={"Fee Receipt"}>Fee Receipt</Option>
                                                </Select>
                                            </Row> */}
                                        </>
                                        : null}
                                    {
                                        courseArray && courseArray.length > 0 && this.state.vendorId ?
                                            <Row style={{ marginTop: 10 }}>
                                                <Col span={6}>
                                                    <div className={styles.formLabel}>
                                                        Date of Transfer
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <Input
                                                        type={'date'}
                                                        value={this.state.swiftTransferDate}
                                                        max={new Date().toISOString().split("T")[0]}
                                                        // disabled={!showChannelPartner}
                                                        required={true}
                                                        format={dateFormat}
                                                        onChange={(v) => {
                                                            this.setState({
                                                                swiftTransferDate: v.target.value
                                                            });
                                                        }} />
                                                </Col>
                                            </Row>

                                            : null
                                    }
                                    <Row style={{ marginTop: 10 }}>
                                        <Col span={4}>
                                            <div style={{ textAlign: 'center' }}>
                                                <Button loading={this.props.loading}
                                                    type="primary" onClick={() => this.updateStatus()}>
                                                    Update
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>

                            {this.state.fileStatusFinal === 'Visa File Dispatched' || this.state.fileStatusFinal === "Visa File Submission" ?
                                <Row style={{ marginTop: 50 }}>
                                    <Col>
                                        <div>
                                            <h2 style={{ marginLeft: 5 }}>Visa Application (To Be Filled By Visa Filling Team) </h2>
                                            <Row style={{ marginTop: 40 }}>
                                                <Col span={8}>File Status :</Col>
                                                <Col span={16}><h3>{this.state.fileStatusFinal === 'Visa File Dispatched' ? 'Visa File Submission' : this.state.fileStatusFinal} ( Date
                                                    : {visaDate ? moment(visaDate, 'DD-MM-YYYY').format(dateFormat) : null} ) </h3></Col>
                                            </Row>

                                            <Form onSubmit={this.handleSubmit} name="asdf" className={styles.marginTop10}>
                                                <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                                    <Col span={8}><label htmlFor="studentVisaType" className="ant-form-item-required" title="Student Visa Type">Student Visa Type</label></Col>
                                                    <Col span={16}>
                                                        <Select value={this.state.studentVisaType}
                                                            style={{ width: 389 }}
                                                            showSearch={true}
                                                            required={true}
                                                            onChange={(v) => {
                                                                this.props.form.setFieldsValue({ studentVisaType: v })
                                                                this.setState({ studentVisaType: v })
                                                                if (v != 'OffShore (Native to Abroad)') {
                                                                    this.setState({ studentVisaTypeField: true })
                                                                } else {
                                                                    this.setState({ studentVisaTypeField: false })
                                                                }
                                                            }}>
                                                            {['OffShore (Native to Abroad)', 'OffShore (Abroad to Abroad)', 'OnShore'].map((item, key) => {
                                                                return (
                                                                    <Option key={key} value={item}>{item}</Option>
                                                                )
                                                            })}
                                                        </Select>
                                                    </Col>
                                                </Row>
                                                {
                                                    studentVisaTypeField ?
                                                        <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                                            <Col span={8} className={styles.fileStatusLabel}><label htmlFor="studentVisionId" className="ant-form-item-required" title="Related Vision ID">Related Vision ID</label></Col>
                                                            <Col span={16}>
                                                                <AutoComplete
                                                                    value={this.state.studentVisionId}
                                                                    dataSource={this.state.dataSource}
                                                                    style={{ width: 389 }}
                                                                    onSelect={this.onSelect}
                                                                    onSearch={this.handleSearch}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        : null
                                                }
                                                <GetAllFormFields
                                                    apiurl={LAPI_URL}
                                                    inputSchema={inputFields}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />

                                                {/* Upload Visa फ़ील्ड के ठीक नीचे या पास में इसे रख सकते हैं */}
                                                {this.state.savedVisa && this.state.savedVisa.visaUpload && this.state.savedVisa.visaUpload.length > 0 && (
                                                    <div style={{ marginTop: 5, marginBottom: 10 }}>
                                                        <span style={{ marginRight: 10 }}>Already Uploaded Visa:</span>
                                                        <Button
                                                            size="small"
                                                            icon="eye"
                                                            onClick={() => {
                                                                const fileUrl = MEDIA_URL + this.state.savedVisa.visaUpload[0].url;
                                                                window.open(fileUrl, '_blank');
                                                            }}
                                                        >
                                                            View Document
                                                        </Button>
                                                    </div>
                                                )}

                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ textAlign: 'left' }} className={styles.marginTop10}>
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            style={{ marginRight: '30px' }}
                                                            loading={this.props.loading}>
                                                            Save Details
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>
                                    </Col>
                                </Row>
                                : null}
                        </Col>
                        <Col span={1}></Col>
                        <Col span={6}>
                            <div>
                                <h2>Get Visa Checklist </h2>
                                <div className={styles.checkListLabel}>Select Country</div>
                                <Select style={{ width: 200 }} onChange={(v) => {
                                    this.setState({
                                        checkListIndex: v,
                                        offerurl: ''
                                    })
                                }} value={this.state.checkListIndex}>
                                    {
                                        countryArr.map((item, key) => {
                                            return (
                                                <Option key={key} value={key}>{item.display}</Option>
                                            )
                                        })
                                    }
                                </Select>
                                <Button type="primary" onClick={() => this.downloadFile()}
                                    className={styles.marginTop10}
                                >
                                    Download
                                </Button>&nbsp;&nbsp;
                                <Button type="default" onClick={() => this.emailCheckList()}
                                    className={styles.marginTop10}
                                    loading={this.state.emailLoader}>
                                    Email
                                </Button>
                                {offerurl ?
                                    <Row className={styles.marginTop10}>
                                        <Col>
                                            <a
                                                href={`${offerurl}`}
                                                style={{
                                                    color: 'blue',
                                                    textDecorationLine: 'underline'
                                                }}
                                                target={'_blank'}>
                                                Download Offer <Icon type="download" />
                                            </a>
                                        </Col>
                                    </Row> : ''}
                            </div>
                        </Col>
                    </Row>
                </Card>
                {!!this.state.visible && <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                    visible={this.state.visible}
                    width={1000}>
                    <AddBranch formOnly={true} afterSave={() => {
                        this.loadAssociativePartners('Associate Partner')
                    }} />
                </Drawer>}
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisaProcessing)
